angular.module('picmonicng').factory('Pathways', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v2/pathways/:pathway_id/:resource/:resource_id',
      {
        pathway_id: '@pathway_id',
        resource: '@resource',
        resource_id: '@resource_id',
      },
      {
        getv3: {
          method: 'GET',
          url: '/api/v3/pathways/:pathway_id/:resource/:resource_id',
          isArray: false,
        },
        queryv3: {
          method: 'GET',
          url: '/api/v3/pathways/:pathway_id/:resource/:resource_id',
          isArray: true,
        },
        update: { method: 'PUT' },
        restore: {
          method: 'POST',
          url: '/api/v2/pathways/:pathway_id/restore',
          isArray: false,
        },
      }
    );
  },
]);
